import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderNumber = params.get("order");
  return (
    <div className="min-h-screen bg-background"><Header />
      <div className="max-w-xl mx-auto text-center py-24 px-4" data-testid="payment-cancel-page">
        <XCircle className="mx-auto text-amber-500" size={56} />
        <h1 className="mt-4 text-3xl font-extrabold">Payment cancelled</h1>
        <p className="mt-3 text-muted-foreground">
          {orderNumber ? <>Order <strong>{orderNumber}</strong> is still awaiting payment.</> : "No payment was taken."} You can complete it from checkout or choose another method.
        </p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button className="bg-steel text-white" data-testid="retry-checkout-btn" onClick={() => navigate("/checkout")}>Back to Checkout</Button>
          <Button variant="outline" onClick={() => navigate("/")}>Continue Shopping</Button>
        </div>
      </div>
    </div>
  );
}
